// extracted by mini-css-extract-plugin
export default {"card":"discoverCard_card__dwjNG","card__img":"discoverCard_card__img__G0GSp","card__title":"discoverCard_card__title__mewMT"};